import React from 'react';

function Card(props) {
  
    const { img, title, text, subtitle } = props;
  

  return (
    <section className="card-chat" role="region" aria-label={title}>
      <figure className="figure-chat" aria-hidden="true">
        <img src={img} alt="Ilustración Lia" />
      </figure>

      <div className="content-chat">
        <h2 className="title-chat">{title}</h2>
        {subtitle ? <p className="sub-chat">{subtitle}</p> : null}
        <p className="desc-chat">{text}</p>
      </div>
    </section>
);
}

export default Card;